import { FC } from 'react';
import { Formik } from 'formik';
import CheckIcon from '@material-ui/icons/Check';
import { Box } from '@material-ui/core';
import { useCustomErrors } from 'Hooks/useCustomErrors';
import {
  productEnhancerValidations,
  PRODUCT_ENHANCER_INITIAL_VALUES,
  PRODUCT_ENHANCER_VALIDATION_SCHEMAS
} from './config';
import { EnhancerFormHeader, EnhancerFormTextField } from './components';
import {
  EnhancerForm,
  EnhancerFormContainer,
  EnhancerFormControlsButton
} from './styled';

// ! types
export interface IProductEnhancerFormProps {
  onClose: () => void;
  onSubmit: (values: IProductEnhancerFormValues) => void;
}

export interface IProductEnhancerFormValues {
  productName: string;
  manufacturerSKU: string;
  manufacturerName: string;
}

// ! component definition
export const ProductEnhancerForm: FC<IProductEnhancerFormProps> = ({
  onClose,
  onSubmit
}) => {
  const { customErrors, customValidate } = useCustomErrors({
    schemas: PRODUCT_ENHANCER_VALIDATION_SCHEMAS,
    values: PRODUCT_ENHANCER_INITIAL_VALUES
  });

  const checkIfDisabled = (formValues: IProductEnhancerFormValues) => {
    const isFull = Object.values(formValues).every(Boolean);
    if (!isFull) return true;

    return Object.values(customErrors).some(Boolean);
  };

  return (
    <EnhancerFormContainer>
      <EnhancerFormHeader onClose={onClose} />

      {/* FORM */}
      <Formik<IProductEnhancerFormValues>
        initialValues={PRODUCT_ENHANCER_INITIAL_VALUES}
        onSubmit={onSubmit}>
        {({ values }) => (
          <EnhancerForm>
            <EnhancerFormTextField
              required
              type="text"
              textFieldSize="small"
              name="productName"
              label="Product Name"
              placeholder="Enter product name"
              onChange={(value: string) =>
                customValidate({
                  schema: productEnhancerValidations.productName,
                  value,
                  name: 'productName'
                })
              }
              customErrors={customErrors}
            />

            <EnhancerFormTextField
              required
              type="text"
              textFieldSize="small"
              name="manufacturerName"
              label="Manufacturer Name"
              placeholder="Enter a manufacturer name"
              onChange={(value: string) =>
                customValidate({
                  schema: productEnhancerValidations.manufacturerName,
                  value,
                  name: 'manufacturerName'
                })
              }
              customErrors={customErrors}
            />

            <EnhancerFormTextField
              required
              type="text"
              textFieldSize="small"
              name="manufacturerSKU"
              label="Manufacturer SKU"
              placeholder="Enter manufacturer SKU"
              onChange={(value: string) =>
                customValidate({
                  schema: productEnhancerValidations.manufacturerSKU,
                  value,
                  name: 'manufacturerSKU'
                })
              }
              customErrors={customErrors}
            />

            {/* FORM CONTROLS */}
            <Box display="flex" justifyContent="space-between">
              <EnhancerFormControlsButton
                color="inherit"
                variant="text"
                onClick={onClose}>
                Cancel
              </EnhancerFormControlsButton>

              <EnhancerFormControlsButton
                type="submit"
                color="primary"
                variant="contained"
                startIcon={<CheckIcon />}
                disabled={checkIfDisabled(values)}>
                Next
              </EnhancerFormControlsButton>
            </Box>
          </EnhancerForm>
        )}
      </Formik>
    </EnhancerFormContainer>
  );
};
